<template>
  <span
    :class="{
      'dropdown-caret': true,
      'dropdown-caret--flipped': props.isFlipped,
      'dropdown-caret--white': props.color === 'white',
    }"
    v-html="caretDown"
  />
</template>

<script setup lang="ts">
import caretDown from '@icons/other/caret-down.svg';

const props = withDefaults(
  defineProps<{
    isFlipped: boolean;
    color?: 'default' | 'white';
  }>(),
  {
    color: 'default',
  }
);
</script>

<style scoped lang="scss">
@import '@styles/variables';

.dropdown-caret {
  transition: transform 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;

  :deep(svg) {
    width: 1rem;
    height: 0.5rem;
    fill: $c-dark;
  }

  &--white {
    :deep(svg) {
      fill: #fff;
    }
  }

  &--flipped {
    transform: rotate(180deg);
  }
}
</style>
